import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Careers' }]

const CareersPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">Careers</h1>

		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Are you looking for a career in an insurance agency? We might be looking
			for you, too!
		</p>

		<section>
			<article>
				<Link
					to="/careers/sales/"
					prefetch="intent"
					className="text-blue-600 underline"
				>
					<h2>Sales</h2>
				</Link>
			</article>
			<article className="style2">
				<Link
					to="/careers/customer-service/"
					prefetch="intent"
					className="text-blue-600 underline"
				>
					<h2>Service</h2>
				</Link>
			</article>
			<article>
				<Link
					to="/careers/receptionist/"
					prefetch="intent"
					className="text-blue-600 underline"
				>
					<h2>Receptionist</h2>
				</Link>
			</article>
		</section>
	</main>
)

export default CareersPage
